export default "__VITE_ASSET__DPyIxY4A__"